/*! @azure/msal-common v14.0.0 2023-08-08 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "14.0.0";

export { name, version };
//# sourceMappingURL=packageMetadata.js.map
